module.exports = __webpack_public_path__ + "static/water_garden_bg-6703377edb2261fd6362515019bbdef5.svg";